<template>
  <running-join-request-data-table :allrunningparticipants="allrunningparticipants"></running-join-request-data-table>
</template>

<script>
import RunningJoinRequestDataTable from './RunningJoinRequestDataTable.vue';

export default {
  props: {
    allrunningparticipants: {
      type: Array,
      required: true
    }
  },
  components: { RunningJoinRequestDataTable },
}
</script>